import { NumericFormat } from "react-number-format";
import Input from "../../input";
import { NumberControlProps } from "../types";

export default function NumberControl(
  props: Readonly<Omit<NumberControlProps, "type">>,
) {
  const {
    size,
    error,
    value,
    thousandSeparator = ",",
    thousandsGroupStyle = "thousand",
    onChange,
    getInputRef,
    ...rest
  } = props;

  return (
    <NumericFormat
      {...rest}
      value={value ?? ""}
      getInputRef={getInputRef}
      onValueChange={(value, source) => {
        if (source.source === "event") {
          onChange?.(value.floatValue);
        }
      }}
      customInput={Input}
      onClick={rest.onClick ?? ((e: React.MouseEvent) => e.stopPropagation())}
      size={size}
      error={error}
      thousandSeparator={thousandSeparator}
      thousandsGroupStyle={thousandsGroupStyle}
    />
  );
}
